"use strict";

const { schedulePathForYear } = require("../config/scheduleArchive");

const scheduleUpdate = (
  datePublished,
  {
    isNew = false,
    scheduleYear = Number(datePublished.slice(0, 4)),
  } = {}
) => ({
  id: `news-${datePublished}-schedule-update`,
  datePublished,
  headline: "公演スケジュールを更新しました",
  summary: "公演スケジュールに出演情報を追加しました。",
  paragraphs: ["公演スケジュールに出演情報を追加しました。"],
  links: [
    {
      to: schedulePathForYear(scheduleYear),
      label: "公演スケジュールを見る",
    },
  ],
  showOnHome: datePublished === "2026-11-01",
  isNew,
});

const rawNewsItems = [
  scheduleUpdate("2026-11-01", { isNew: true }),
  scheduleUpdate("2026-08-21"),
  scheduleUpdate("2026-05-17"),
  scheduleUpdate("2026-02-22"),
  scheduleUpdate("2025-11-05"),
  scheduleUpdate("2025-09-13"),
  scheduleUpdate("2025-02-27"),
  scheduleUpdate("2025-01-25"),
  scheduleUpdate("2024-11-01"),
  scheduleUpdate("2024-09-05"),
  scheduleUpdate("2024-08-08"),
  scheduleUpdate("2024-07-23"),
  scheduleUpdate("2024-07-14"),
  scheduleUpdate("2024-06-28"),
  {
    id: "news-2024-03-18-nagoya-italian-opera-competition",
    datePublished: "2024-03-18",
    headline: "コンクール結果のご報告",
    summary: "第1回名古屋イタリアオペラコンクールの結果をご報告します。",
    paragraphs: [
      "2024年3月3日に開催された「第1回名古屋イタリアオペラコンクール」本選（於：名古屋市港文化小劇場）において、優秀賞およびプッチーニ賞を受賞させていただきました。副賞として11月には名古屋市中区のHITOMIホールにてデュオリサイタルをさせて頂けることとなりました。また詳細が分かり次第ご案内させていただきます。そちらも是非観に来て頂ければと思います。",
      "今後とも何卒よろしくお願い申し上げます。",
      "本多信明",
      "以下歌った曲目です。\n予選（映像）　Spirto gentil  G.Donizetti “La Favorita”\n本選　Che gelida mania  G.Puccini “La Bohème”",
    ],
    links: [
      {
        href: "https://impa.jp/nagoya_italy/2023/",
        label: "第1回名古屋イタリアオペラコンクール公式サイト",
      },
    ],
    showOnHome: true,
    isNew: false,
  },
  scheduleUpdate("2024-01-20"),
  scheduleUpdate("2024-01-03"),
  scheduleUpdate("2023-12-05"),
  scheduleUpdate("2023-10-25"),
  scheduleUpdate("2023-09-13"),
  {
    id: "news-2023-08-11-tokushima-performance-press-coverage",
    datePublished: "2023-08-11",
    headline: "徳島公演の新聞掲載のお知らせ",
    summary: "8月5日徳島での公演が徳島経済新聞に掲載されました。",
    paragraphs: [
      "8月5日（土）徳島で行われた「オペラ『椿姫』を100倍楽しむために」の公演の模様が徳島経済新聞に掲載されました。",
      "詳細は以下のリンクよりご覧ください。",
    ],
    links: [
      {
        href: "https://tokushima.keizai.biz/headline/462/",
        label: "徳島経済新聞の記事を読む",
      },
    ],
    showOnHome: true,
    isNew: false,
  },
  {
    id: "news-2023-07-27-nichii-concorso-second-prize",
    datePublished: "2023-07-27",
    headline: "第59回日伊声楽コンコルソ 第2位受賞のご報告",
    summary: "第59回日伊声楽コンコルソ2023本選での第2位受賞をご報告します。",
    paragraphs: [
      "2023年7月25日に開催された「第59回日伊声楽コンコルソ2023」本選にて第2位を受賞させていただきました。応援してくださった皆様本当にありがとうございます。これからも一層研鑽に励む所存です。11月17日にはよみうり大手町ホールにて入賞者披露演奏会が行われます。また詳細が分かり次第ご案内させていただきます。そちらも是非観に来て頂ければと思います。",
      "今後とも何卒よろしくお願い申し上げます。",
      "本多信明",
      "以下歌った曲目です。\n1次予選　Spirto gentil  G.Donizetti “La Favorita”\n2次予選　Malinconia, Ninfa gentile  V.Bellini\n　　　　　Quando le sere al placido  G.Verdi “Luisa Miller”\n本選　　　L’alba separa dalla luce l’ombra  F.P.Tosti\n　　　　　La mia letizia infondere  G.Verdi “I Lombardi alla prima crociata”\n　　　　　Spirto gentil  G.Donizetti “La Favorita”",
    ],
    links: [
      {
        href: "https://www.nichii-concorso.com/news_detail.php?id=00074.xml",
        label: "第59回日伊声楽コンコルソ公式サイト",
      },
    ],
    showOnHome: true,
    isNew: false,
  },
  scheduleUpdate("2023-06-20"),
  scheduleUpdate("2022-12-30", { scheduleYear: 2023 }),
  scheduleUpdate("2022-10-31"),
  scheduleUpdate("2022-09-18"),
  {
    id: "news-2020-10-14-youtube-channel",
    datePublished: "2020-10-14",
    headline: "演奏音源・動画をYouTubeに公開しました",
    summary: "演奏音源、動画をYouTubeに公開しました。",
    paragraphs: ["演奏音源、動画をYouTubeに公開しました。"],
    links: [
      {
        href: "https://www.youtube.com/channel/UCFfB_K0HHo4zl9hcjG6_pyw",
        label: "本多信明YouTubeチャンネル",
      },
    ],
    showOnHome: true,
    isNew: false,
  },
  {
    id: "news-2020-10-14-official-site-launch",
    datePublished: "2020-10-14",
    headline: "公式サイトを公開しました",
    summary: "本多信明公式サイトを公開しました。",
    paragraphs: [
      "公式サイトを公開しました。",
      "演奏の音源や動画、最新情報を掲載しております。ぜひご覧ください。",
    ],
    links: [],
    showOnHome: false,
    isNew: false,
  },
  {
    id: "news-2020-03-07-tsuki-no-kage-postponement",
    datePublished: "2020-03-07",
    headline: "オペラ「月の影 - 源氏物語 - 」出演のお知らせ",
    summary: "オペラ「月の影 - 源氏物語 - 」に光源氏役で出演します。",
    paragraphs: [
      "オペラ「月の影 - 源氏物語 - 」出演　光源氏役\n名古屋市芸術創造センター\n（公演延期）",
    ],
    links: [],
    showOnHome: false,
    isNew: false,
  },
  {
    id: "news-2020-01-02-nhk-etv-rebroadcast",
    datePublished: "2020-01-02",
    headline: "NHK Eテレ「“わたし”という名の楽器」再放送出演のお知らせ",
    summary: "NHK Eテレ「“わたし”という名の楽器」の再放送に出演します。",
    paragraphs: [
      "1月2日（木）13:30〜14:30 再放送\nNHK Eテレ1東京\n「“わたし”という名の楽器」\n〜第88回日本音楽コンクール〜 出演",
    ],
    links: [],
    showOnHome: false,
    isNew: false,
  },
];

const NEWS_ID_PATTERN = /^news-\d{4}-\d{2}-\d{2}-[a-z0-9]+(?:-[a-z0-9]+)*$/;
const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

const isRealIsoDate = (value) => {
  const match = ISO_DATE_PATTERN.exec(value);
  if (!match) {
    return false;
  }

  const year = Number(match[1]);
  const month = Number(match[2]);
  const day = Number(match[3]);
  const date = new Date(Date.UTC(year, month - 1, day));

  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
};

const validateNewsItems = (items) => {
  const ids = new Set();

  items.forEach((item, index) => {
    if (!NEWS_ID_PATTERN.test(item.id)) {
      throw new Error(`Invalid news id: ${item.id}`);
    }
    if (ids.has(item.id)) {
      throw new Error(`Duplicate news id: ${item.id}`);
    }
    ids.add(item.id);

    if (!isRealIsoDate(item.datePublished)) {
      throw new Error(`Invalid news publication date: ${item.datePublished}`);
    }
    if (
      index > 0 &&
      items[index - 1].datePublished < item.datePublished
    ) {
      throw new Error("News items must be ordered by publication date descending.");
    }

    ["headline", "summary"].forEach((field) => {
      if (typeof item[field] !== "string" || !item[field].trim()) {
        throw new Error(`Missing ${field} for news item: ${item.id}`);
      }
    });

    if (
      !Array.isArray(item.paragraphs) ||
      !item.paragraphs.length ||
      item.paragraphs.some(
        (paragraph) => typeof paragraph !== "string" || !paragraph.trim()
      )
    ) {
      throw new Error(`Invalid paragraphs for news item: ${item.id}`);
    }
    if (!Array.isArray(item.links)) {
      throw new Error(`Invalid links for news item: ${item.id}`);
    }

    item.links.forEach((link) => {
      const hasInternalTarget = typeof link.to === "string";
      const hasExternalTarget = typeof link.href === "string";

      if (hasInternalTarget === hasExternalTarget) {
        throw new Error(`Invalid link target for news item: ${item.id}`);
      }
      if (
        typeof link.label !== "string" ||
        !link.label.trim() ||
        link.label === "こちら" ||
        /^https?:\/\//i.test(link.label)
      ) {
        throw new Error(`Invalid link label for news item: ${item.id}`);
      }
      if (
        hasInternalTarget &&
        (!link.to.startsWith("/") || link.to.startsWith("//"))
      ) {
        throw new Error(`Invalid internal link for news item: ${item.id}`);
      }
      if (hasExternalTarget && !/^https:\/\//i.test(link.href)) {
        throw new Error(`External news links must use HTTPS: ${item.id}`);
      }
    });

    if (
      typeof item.showOnHome !== "boolean" ||
      typeof item.isNew !== "boolean"
    ) {
      throw new Error(`Invalid news display flags: ${item.id}`);
    }
  });

  if (items.filter((item) => item.showOnHome).length !== 5) {
    throw new Error("Exactly five news items must be selected for the home page.");
  }
};

const deepFreeze = (value) => {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) {
    return value;
  }

  Object.getOwnPropertyNames(value).forEach((property) => {
    deepFreeze(value[property]);
  });

  return Object.freeze(value);
};

validateNewsItems(rawNewsItems);

const newsItems = deepFreeze(rawNewsItems);
const homeNewsItems = Object.freeze(
  newsItems.filter((item) => item.showOnHome)
);

const formatNewsDate = (datePublished) => {
  if (!isRealIsoDate(datePublished)) {
    throw new Error(`Invalid news publication date: ${datePublished}`);
  }

  const [year, month, day] = datePublished.split("-").map(Number);
  return `${year}年${month}月${day}日`;
};

module.exports = Object.freeze({
  formatNewsDate,
  homeNewsItems,
  newsItems,
});
